/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ContextMenuChannelCrossPointFragment = {
	id: string;
	inputChannel:
		| { id: string; isAudioChannel: 'AudioChannel' }
		| { id: string; audioChannelId: string; isStereoAudioChannel: 'StereoAudioChannel' };
	features: { configuration: { enabled: boolean | null } | null };
};

export type ContextMenuChannelCrossPointFragmentUpdate = {
	id: string;
	features: { configuration: { enabled: boolean | null } | null } | {};
};

export type ContextMenuChannelEqualizerFilterFragment = {
	id: string;
	description: {
		constraints: {
			gain: { gain: { range: { step: number } } } | null;
			configuration: { filterType: { options: Array<Types.EqFilterType> | null } | null } | null;
		};
	};
	features: { configuration: { enabled: boolean } | null };
};

export type ContextMenuChannelEqualizerFilterFragmentUpdate = {
	id: string;
	features: { configuration: { enabled: boolean } | null } | {};
};

export type ContextMenuChannelFragment = {
	id: string;
	isAudioChannelNode: 'AudioChannel';
	description: {
		groupName: string;
		constraints: {
			analogLevel: { level: { options: Array<Types.AnalogLevel> } } | null;
			gain: { gain: { range: { max: number; min: number; step: number } } } | null;
			rms: { level: { range: { max: number; min: number; step: number } } } | null;
			inputSource: { source: { options: Array<Types.AudioChannelInputSourceType> } | null } | null;
			outputPath: { path: { options: Array<Types.OutputSignalPath> } } | null;
		};
		features: {
			autoMute: { supported: boolean };
			analogLevel: { supported: boolean };
			acousticEchoCancellation: { supported: boolean };
			acousticEchoCancellationMonoReference: { supported: boolean };
			automaticGainControl: { supported: boolean };
			compressor: { supported: boolean };
			delay: { supported: boolean };
			equalizer: { supported: boolean };
			limiter: { supported: boolean };
			noiseReduction: { supported: boolean };
			denoiser: { supported: boolean };
			deverb: { supported: boolean };
			name: { supported: boolean };
			gain: { supported: boolean };
			mute: { supported: boolean };
			postGateMute: { supported: boolean };
			danteEncryptionStatus: { supported: boolean };
			rms: { supported: boolean };
			pcPeripheral: { supported: boolean };
			stereoRms: { supported: boolean };
			stereoPeak: { supported: boolean };
			inputSource: { supported: boolean };
			outputPath: { supported: boolean };
			passiveSpeakers: { supported: boolean };
			channelConfiguration: { supported: boolean };
			carriedByRfChannels: { supported: boolean };
			analogInputUse: { supported: boolean };
			channelBonding: { supported: boolean };
		};
	};
	features: {
		autoMute: { enabled: boolean } | null;
		analogLevel: { level: Types.AnalogLevel } | null;
		acousticEchoCancellation: { enabled: boolean } | null;
		acousticEchoCancellationMonoReference: { selectedReferenceSource: { id: string } } | null;
		acousticEchoCancellationStereoReference: {
			selectedLeftReferenceSource: { id: string };
			selectedRightReferenceSource: { id: string };
		} | null;
		automaticGainControl: { enabled: boolean } | null;
		compressor: { enabled: boolean | null } | null;
		delay: { enabled: boolean } | null;
		equalizer: { filters: Array<ContextMenuChannelEqualizerFilterFragment> } | null;
		limiter: { enabled: boolean } | null;
		noiseReduction: { enabled: boolean } | null;
		denoiser: { enabled: boolean } | null;
		deverb: { enabled: boolean } | null;
		name: { name: string } | null;
		gain: { gain: number } | null;
		mute: { muted: boolean } | null;
		danteEncryptionStatus: { status: Types.DanteAudioEncryptionStatus } | null;
		postGateMute: { muted: boolean } | null;
		pcPeripheral: {
			peripheralOptions: Array<{ id: string; name: string; status: Types.PcPeripheralStatus }>;
			selectedPeripheral: { id: string; name: string; status: Types.PcPeripheralStatus } | null;
		} | null;
		inputSource: { source: Types.AudioChannelInputSourceType } | null;
		outputPath: { path: Types.OutputSignalPath } | null;
		passiveSpeakers: { type: Types.SpeakerType } | null;
		channelConfiguration: { enabled: boolean } | null;
		carriedByRfChannels: { rfChannels: Array<ContextMenuRfChannelFragment> } | null;
		analogInputUse: { mode: Types.AnalogInputUseMode } | null;
		channelBonding: { spatialSeparation: Types.StereoAudioChannelSpatialSeparation } | null;
	};
};

export type ContextMenuRfChannelFragment = {
	id: string;
	description: { features: { linkedTransmitter: { supported: boolean } } };
	features: {
		linkedTransmitter: {
			linkage: {
				device: {
					id: string;
					status: Types.DeviceStatus;
					features: { micStatusV2: { status: Types.MicStatusV2 } | null };
				} | null;
			} | null;
		} | null;
	};
};

export type ContextMenuChannelFragmentUpdate = {
	id: string;
	features:
		| { acousticEchoCancellation: { enabled: boolean } | null }
		| { acousticEchoCancellationMonoReference: { selectedReferenceSource: { id: string } } | null }
		| {
				acousticEchoCancellationStereoReference: {
					selectedLeftReferenceSource: { id: string };
					selectedRightReferenceSource: { id: string };
				} | null;
		  }
		| { analogInputUse: { mode: Types.AnalogInputUseMode } | null }
		| { analogLevel: { level: Types.AnalogLevel } | null }
		| { automaticGainControl: { enabled: boolean } | null }
		| { channelConfiguration: { enabled: boolean } | null }
		| { compressor: { enabled: boolean | null } | null }
		| { danteEncryptionStatus: { status: Types.DanteAudioEncryptionStatus } | null }
		| { delay: { enabled: boolean } | null }
		| { denoiser: { enabled: boolean } | null }
		| { deverb: { enabled: boolean } | null }
		| { equalizer: { enabled: boolean | null } | null }
		| { gain: { gain: number } | null }
		| { inputSource: { source: Types.AudioChannelInputSourceType } | null }
		| { limiter: { enabled: boolean } | null }
		| { mute: { muted: boolean } | null }
		| { name: { name: string } | null }
		| { noiseReduction: { enabled: boolean } | null }
		| { outputPath: { path: Types.OutputSignalPath } | null }
		| {
				pcPeripheral: {
					peripheralOptions: Array<{ id: string; name: string; status: Types.PcPeripheralStatus }>;
					selectedPeripheral: { id: string; name: string; status: Types.PcPeripheralStatus } | null;
				} | null;
		  }
		| { postGateMute: { muted: boolean } | null }
		| {
				selectedLoudspeaker: {
					loudspeaker: Types.Loudspeaker;
					loudspeakerOptions: Array<Types.Loudspeaker>;
				} | null;
		  }
		| {};
};

export type GetChannelQueryVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
}>;

export type GetChannelQueryOpResult = { node: ContextMenuChannelFragment | {} };

export type UpdateChannelMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type UpdateChannelMutationOpResult = {
	updateNodes: Array<{ error: { code: Types.ErrorCode; message: string } | null } | {}>;
};

export type AecMonoReferenceMutationVariables = Types.Exact<{
	input: Types.AudioChannelAcousticEchoCancellationMonoReferenceInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type AecMonoReferenceMutationOpResult = {
	updateAcousticEchoCancellationMonoReferenceSource: { error: { code: Types.ErrorCode; message: string } | null };
};

export type AecStereoReferenceMutationVariables = Types.Exact<{
	input: Types.AudioChannelAcousticEchoCancellationStereoReferenceInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type AecStereoReferenceMutationOpResult = {
	updateAcousticEchoCancellationStereoReferenceSource: { error: { code: Types.ErrorCode; message: string } | null };
};

export type ChannelSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type ChannelSubscriptionOpResult = {
	nodeChanges: ContextMenuChannelFragment | ContextMenuChannelFragmentUpdate | {};
};

export type ChannelCrossPointSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type ChannelCrossPointSubscriptionOpResult = {
	nodeChanges: ContextMenuChannelCrossPointFragment | ContextMenuChannelCrossPointFragmentUpdate | {};
};

export type ChannelEqualizerFilterSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type ChannelEqualizerFilterSubscriptionOpResult = {
	nodeChanges: ContextMenuChannelEqualizerFilterFragment | ContextMenuChannelEqualizerFilterFragmentUpdate | {};
};

export type ContextMenuDeviceRfChannelSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type ContextMenuDeviceRfChannelSubscriptionOpResult = {
	nodeChanges: ContextMenuRfChannelFragment | ContextMenuRfChannelUpdateFragment | {};
};

export type ContextMenuRfChannelUpdateFragment = {
	id: string;
	features: { linkedTransmitter: { linkage: { device: { id: string } | null } | null } | null } | {};
};

export const ContextMenuChannelCrossPointFragment = gql`
	fragment ContextMenuChannelCrossPointFragment on CrossPoint {
		id
		inputChannel {
			... on AudioChannel {
				isAudioChannel: __typename
				id
			}
			... on StereoAudioChannel {
				isStereoAudioChannel: __typename
				id
				audioChannelId
			}
		}
		features {
			configuration {
				enabled
			}
		}
	}
`;
export const ContextMenuChannelCrossPointFragmentUpdate = gql`
	fragment ContextMenuChannelCrossPointFragmentUpdate on CrossPointChange {
		id
		features {
			... on CrossPointConfigurationChange {
				configuration {
					enabled
				}
			}
		}
	}
`;
export const ContextMenuChannelEqualizerFilterFragmentUpdate = gql`
	fragment ContextMenuChannelEqualizerFilterFragmentUpdate on EqualizerFilterChange {
		id
		features {
			... on EqualizerFilterConfigurationChange {
				configuration {
					enabled
				}
			}
		}
	}
`;
export const ContextMenuChannelEqualizerFilterFragment = gql`
	fragment ContextMenuChannelEqualizerFilterFragment on EqualizerFilter {
		id
		description {
			constraints {
				gain {
					gain {
						range {
							step
						}
					}
				}
				configuration {
					filterType {
						options
					}
				}
			}
		}
		features {
			configuration {
				enabled
			}
		}
	}
`;
export const ContextMenuRfChannelFragment = gql`
	fragment ContextMenuRfChannelFragment on RfChannel {
		id
		description {
			features {
				linkedTransmitter {
					supported
				}
			}
		}
		features {
			linkedTransmitter {
				linkage {
					device {
						id
						status
						features {
							micStatusV2 {
								status
							}
						}
					}
				}
			}
		}
	}
`;
export const ContextMenuChannelFragment = gql`
	fragment ContextMenuChannelFragment on AudioChannel {
		isAudioChannelNode: __typename
		id
		description {
			groupName
			constraints {
				analogLevel {
					level {
						options
					}
				}
				gain {
					gain {
						range {
							max
							min
							step
						}
					}
				}
				rms {
					level {
						range {
							max
							min
							step
						}
					}
				}
				inputSource {
					source {
						options
					}
				}
				outputPath {
					path {
						options
					}
				}
			}
			features {
				autoMute {
					supported
				}
				analogLevel {
					supported
				}
				acousticEchoCancellation {
					supported
				}
				acousticEchoCancellationMonoReference {
					supported
				}
				automaticGainControl {
					supported
				}
				compressor {
					supported
				}
				delay {
					supported
				}
				equalizer {
					supported
				}
				limiter {
					supported
				}
				noiseReduction {
					supported
				}
				denoiser {
					supported
				}
				deverb {
					supported
				}
				name {
					supported
				}
				gain {
					supported
				}
				mute {
					supported
				}
				postGateMute {
					supported
				}
				danteEncryptionStatus {
					supported
				}
				rms {
					supported
				}
				pcPeripheral {
					supported
				}
				stereoRms {
					supported
				}
				stereoPeak {
					supported
				}
				inputSource {
					supported
				}
				outputPath {
					supported
				}
				passiveSpeakers {
					supported
				}
				channelConfiguration {
					supported
				}
				carriedByRfChannels {
					supported
				}
				analogInputUse {
					supported
				}
				channelBonding {
					supported
				}
			}
		}
		features {
			autoMute {
				enabled
			}
			analogLevel {
				level
			}
			acousticEchoCancellation {
				enabled
			}
			acousticEchoCancellationMonoReference {
				selectedReferenceSource {
					id
				}
			}
			acousticEchoCancellationStereoReference {
				selectedLeftReferenceSource {
					id
				}
				selectedRightReferenceSource {
					id
				}
			}
			automaticGainControl {
				enabled
			}
			compressor {
				enabled
			}
			delay {
				enabled
			}
			equalizer {
				filters {
					...ContextMenuChannelEqualizerFilterFragment
				}
			}
			limiter {
				enabled
			}
			noiseReduction {
				enabled
			}
			denoiser {
				enabled
			}
			deverb {
				enabled
			}
			name {
				name
			}
			gain {
				gain
			}
			mute {
				muted
			}
			danteEncryptionStatus {
				status
			}
			postGateMute {
				muted
			}
			pcPeripheral {
				peripheralOptions {
					id
					name
					status
				}
				selectedPeripheral {
					id
					name
					status
				}
			}
			inputSource {
				source
			}
			outputPath {
				path
			}
			passiveSpeakers {
				type
			}
			channelConfiguration {
				enabled
			}
			carriedByRfChannels {
				rfChannels {
					...ContextMenuRfChannelFragment
				}
			}
			analogInputUse {
				mode
			}
			channelBonding {
				spatialSeparation
			}
		}
	}
	${ContextMenuChannelEqualizerFilterFragment}
	${ContextMenuRfChannelFragment}
`;
export const ContextMenuChannelFragmentUpdate = gql`
	fragment ContextMenuChannelFragmentUpdate on AudioChannelChange {
		id
		features {
			... on AudioChannelNameChange {
				name {
					name
				}
			}
			... on AudioChannelMuteChange {
				mute {
					muted
				}
			}
			... on AudioChannelGainChange {
				gain {
					gain
				}
			}
			... on AudioChannelAcousticEchoCancellationChange {
				acousticEchoCancellation {
					enabled
				}
			}
			... on AudioChannelAcousticEchoCancellationMonoReferenceChange {
				acousticEchoCancellationMonoReference {
					selectedReferenceSource {
						id
					}
				}
			}
			... on AudioChannelAcousticEchoCancellationStereoReferenceChange {
				acousticEchoCancellationStereoReference {
					selectedLeftReferenceSource {
						id
					}
					selectedRightReferenceSource {
						id
					}
				}
			}
			... on AudioChannelAutomaticGainControlChange {
				automaticGainControl {
					enabled
				}
			}
			... on AudioChannelCompressorChange {
				compressor {
					enabled
				}
			}
			... on AudioChannelDelayChange {
				delay {
					enabled
				}
			}
			... on AudioChannelEqualizerChange {
				equalizer {
					enabled
				}
			}
			... on AudioChannelLimiterChange {
				limiter {
					enabled
				}
			}
			... on AudioChannelNoiseReductionChange {
				noiseReduction {
					enabled
				}
			}
			... on AudioChannelDenoiserChange {
				denoiser {
					enabled
				}
			}
			... on AudioChannelDeverbChange {
				deverb {
					enabled
				}
			}
			... on AudioChannelPostGateMuteChange {
				postGateMute {
					muted
				}
			}
			... on AudioChannelAnalogLevelChange {
				analogLevel {
					level
				}
			}
			... on AudioChannelDanteEncryptionStatusChange {
				danteEncryptionStatus {
					status
				}
			}
			... on AudioChannelPcPeripheralChange {
				pcPeripheral {
					peripheralOptions {
						id
						name
						status
					}
					selectedPeripheral {
						id
						name
						status
					}
				}
			}
			... on AudioChannelInputSourceChange {
				inputSource {
					source
				}
			}
			... on AudioChannelOutputPathChange {
				outputPath {
					path
				}
			}
			... on AudioChannelSelectedLoudspeakerChange {
				selectedLoudspeaker {
					loudspeaker
					loudspeakerOptions
				}
			}
			... on AudioChannelChannelConfigurationChange {
				channelConfiguration {
					enabled
				}
			}
			... on AudioChannelAnalogInputUseChange {
				analogInputUse {
					mode
				}
			}
		}
	}
`;
export const ContextMenuRfChannelUpdateFragment = gql`
	fragment ContextMenuRfChannelUpdateFragment on RfChannelChange {
		id
		features {
			... on RfChannelLinkedTransmitterChange {
				linkedTransmitter {
					linkage {
						device {
							id
						}
					}
				}
			}
		}
	}
`;
export const GetChannelQueryDocument = gql`
	query GetChannelQuery($id: ID!) {
		node(id: $id) {
			...ContextMenuChannelFragment
		}
	}
	${ContextMenuChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class GetChannelQueryGQL extends Apollo.Query<GetChannelQueryOpResult, GetChannelQueryVariables> {
	override document = GetChannelQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const UpdateChannelMutationDocument = gql`
	mutation UpdateChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on AudioChannelOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class UpdateChannelMutationGQL extends Apollo.Mutation<
	UpdateChannelMutationOpResult,
	UpdateChannelMutationVariables
> {
	override document = UpdateChannelMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AecMonoReferenceMutationDocument = gql`
	mutation AecMonoReferenceMutation(
		$input: AudioChannelAcousticEchoCancellationMonoReferenceInput!
		$injectKeyring: String
	) {
		updateAcousticEchoCancellationMonoReferenceSource(input: $input, keyring: $injectKeyring) {
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class AecMonoReferenceMutationGQL extends Apollo.Mutation<
	AecMonoReferenceMutationOpResult,
	AecMonoReferenceMutationVariables
> {
	override document = AecMonoReferenceMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AecStereoReferenceMutationDocument = gql`
	mutation AecStereoReferenceMutation(
		$input: AudioChannelAcousticEchoCancellationStereoReferenceInput!
		$injectKeyring: String
	) {
		updateAcousticEchoCancellationStereoReferenceSource(input: $input, keyring: $injectKeyring) {
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class AecStereoReferenceMutationGQL extends Apollo.Mutation<
	AecStereoReferenceMutationOpResult,
	AecStereoReferenceMutationVariables
> {
	override document = AecStereoReferenceMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const ChannelSubscriptionDocument = gql`
	subscription ChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			...ContextMenuChannelFragment
			...ContextMenuChannelFragmentUpdate
		}
	}
	${ContextMenuChannelFragment}
	${ContextMenuChannelFragmentUpdate}
`;

@Injectable({
	providedIn: 'root'
})
export class ChannelSubscriptionGQL extends Apollo.Subscription<
	ChannelSubscriptionOpResult,
	ChannelSubscriptionVariables
> {
	override document = ChannelSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const ChannelCrossPointSubscriptionDocument = gql`
	subscription ChannelCrossPointSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			...ContextMenuChannelCrossPointFragment
			...ContextMenuChannelCrossPointFragmentUpdate
		}
	}
	${ContextMenuChannelCrossPointFragment}
	${ContextMenuChannelCrossPointFragmentUpdate}
`;

@Injectable({
	providedIn: 'root'
})
export class ChannelCrossPointSubscriptionGQL extends Apollo.Subscription<
	ChannelCrossPointSubscriptionOpResult,
	ChannelCrossPointSubscriptionVariables
> {
	override document = ChannelCrossPointSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const ChannelEqualizerFilterSubscriptionDocument = gql`
	subscription ChannelEqualizerFilterSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			...ContextMenuChannelEqualizerFilterFragment
			...ContextMenuChannelEqualizerFilterFragmentUpdate
		}
	}
	${ContextMenuChannelEqualizerFilterFragment}
	${ContextMenuChannelEqualizerFilterFragmentUpdate}
`;

@Injectable({
	providedIn: 'root'
})
export class ChannelEqualizerFilterSubscriptionGQL extends Apollo.Subscription<
	ChannelEqualizerFilterSubscriptionOpResult,
	ChannelEqualizerFilterSubscriptionVariables
> {
	override document = ChannelEqualizerFilterSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const ContextMenuDeviceRfChannelSubscriptionDocument = gql`
	subscription ContextMenuDeviceRfChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			...ContextMenuRfChannelFragment
			...ContextMenuRfChannelUpdateFragment
		}
	}
	${ContextMenuRfChannelFragment}
	${ContextMenuRfChannelUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class ContextMenuDeviceRfChannelSubscriptionGQL extends Apollo.Subscription<
	ContextMenuDeviceRfChannelSubscriptionOpResult,
	ContextMenuDeviceRfChannelSubscriptionVariables
> {
	override document = ContextMenuDeviceRfChannelSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
